import React from 'react';

const XIcon = () => (
  <svg
    enableBackground="new 0 0 48 48"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Black circular background */}
    <circle cx="24" cy="24" r="24" fill="#000000" />
    {/* White X logo */}
    <path
      fill="#FFFFFF"
      d="M28.56 23.2L39.33 10h-4.29l-8.17 10.02L20.01 10H8l10.87 15.47L8 38h4.29l8.74-10.74L27.97 38H40L28.56 23.2zM24.04 27.2l-2.1-2.8L12.56 12h5.01l6.69 9.2 2.1 2.8 9.62 12.84h-5.01L24.04 27.2z"
    />
  </svg>
);

export default XIcon;
